<template>
  <svg width="311" height="223" viewBox="0 0 311 223" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- eslint-disable vue/max-len -->
    <g filter="url(#filter0_d_1402_21961)">
      <rect
        x="72.7773"
        y="49.5645"
        width="216.872"
        height="126.526"
        rx="23.7968"
        transform="rotate(5.54147 72.7773 49.5645)"
        fill="#F9E2A6"
      />
    </g>
    <g filter="url(#filter1_d_1402_21961)">
      <rect
        x="52.7773"
        y="34.5645"
        width="216.872"
        height="126.526"
        rx="23.7968"
        transform="rotate(5.54147 52.7773 34.5645)"
        fill="#FFF0C9"
      />
    </g>
    <g filter="url(#filter2_d_1402_21961)">
      <rect
        x="41.7773"
        y="21.5645"
        width="216.872"
        height="126.526"
        rx="23.7968"
        transform="rotate(5.54147 41.7773 21.5645)"
        fill="#FFF6DE"
      />
    </g>
    <rect
      x="68.3906"
      y="95.4316"
      width="154.602"
      height="8.25507"
      rx="4.12754"
      transform="rotate(5.54147 68.3906 95.4316)"
      fill="#E8D9AF"
    />
    <rect
      x="67.0352"
      y="109.404"
      width="112.538"
      height="8.25507"
      rx="4.12754"
      transform="rotate(5.54147 67.0352 109.404)"
      fill="#E8D9AF"
    />
    <path d="M79.2684 66.8354L86.2762 67.5153L86.1829 68.4764C85.9965 70.3985 85.2023 71.9181 83.8224 73.0171C82.4425 74.1161 80.7223 74.5555 78.6801 74.3574C76.5177 74.1476 74.8037 73.2739 73.5181 71.7345C72.2525 70.1969 71.7188 68.407 71.9169 66.3647C72.1131 64.3425 72.9809 62.6885 74.5185 61.423C76.078 60.1393 77.8879 59.6075 79.9702 59.8095C82.5932 60.064 84.7494 61.5869 85.7546 63.7257L83.6616 64.6747C83.051 63.2613 81.5747 62.2288 79.7527 62.052C78.291 61.9102 77.0231 62.2723 75.9888 63.1421C74.9545 64.0118 74.3574 65.1665 74.2175 66.6081C74.0777 68.0498 74.4416 69.2977 75.2914 70.3301C76.1612 71.3644 77.3759 71.9673 78.9177 72.1168C81.4004 72.3577 83.1446 71.2537 83.7535 69.3523L79.0683 68.8977L79.2684 66.8354ZM90.7359 63.2389C90.1429 63.7271 89.3019 63.6455 88.7938 63.0505C88.3075 62.4374 88.3891 61.5965 88.9822 61.1083C89.5772 60.6001 90.4582 60.6856 90.9444 61.2987C91.4325 61.8917 91.3509 62.7327 90.7359 63.2389ZM89.7002 75.1638L87.5378 74.954L88.5091 64.9429L90.6715 65.1527L89.7002 75.1638ZM98.8419 61.6405L98.6399 63.7228C97.0717 63.4292 96.2267 64.0141 96.0849 65.4758L96.0655 65.676L98.4281 65.9052L98.2261 67.9875L95.8635 67.7583L95.0942 75.6872L92.9318 75.4774L93.7011 67.5485L92.1794 67.4009L92.3814 65.3186L93.9031 65.4662L93.9225 65.266C94.1886 62.5229 95.8961 61.1728 98.8419 61.6405ZM105.632 66.6041L105.43 68.6864L102.947 68.4455L102.481 73.2509C102.356 74.5323 103.199 74.5939 104.849 74.6731L104.66 76.6153C101.318 76.6952 100.064 75.664 100.318 73.0411L100.784 68.2358L98.9424 68.057L99.1444 65.9747L100.986 66.1534L101.196 63.991L103.421 63.5601L103.149 66.3632L105.632 66.6041ZM118.282 67.8315L118.08 69.9138L115.598 69.6729L115.131 74.4783C115.007 75.7597 115.85 75.8213 117.5 75.9005L117.311 77.8426C113.969 77.9226 112.715 76.8914 112.969 74.2685L113.435 69.4631L111.593 69.2844L111.795 67.2021L113.637 67.3808L113.847 65.2184L116.072 64.7875L115.8 67.5906L118.282 67.8315ZM122.471 66.3178C121.877 66.8059 121.037 66.7243 120.528 66.1294C120.042 65.5163 120.124 64.6753 120.717 64.1872C121.312 63.679 122.193 63.7645 122.679 64.3776C123.167 64.9706 123.086 65.8115 122.471 66.3178ZM121.435 78.2427L119.272 78.0329L120.244 68.0218L122.406 68.2316L121.435 78.2427ZM130.608 68.7646C131.99 68.8986 133.101 69.5319 133.983 70.6482C134.865 71.7645 135.225 73.0525 135.083 74.5142C134.939 75.9958 134.338 77.1906 133.258 78.1165C132.178 79.0425 130.968 79.4304 129.587 79.2963C128.065 79.1487 126.958 78.4754 126.246 77.2745L125.719 82.7006L123.557 82.4908L124.917 68.4752L127.079 68.6849L126.939 70.1266C127.871 69.0649 129.087 68.617 130.608 68.7646ZM127.271 76.0805C127.814 76.7395 128.545 77.1136 129.446 77.201C130.347 77.2884 131.137 77.0619 131.796 76.5195C132.457 75.9571 132.831 75.2254 132.921 74.3044C133.01 73.3833 132.784 72.5934 132.241 71.9344C131.701 71.2554 130.969 70.8813 130.068 70.7939C129.167 70.7065 128.377 70.933 127.716 71.4954C127.057 72.0378 126.683 72.7695 126.594 73.6905C126.504 74.6116 126.731 75.4015 127.271 76.0805ZM139.007 72.6313C138.943 73.292 139.751 73.714 140.763 74.1153C142.272 74.6053 144.212 75.4402 143.964 77.5788C143.871 78.5398 143.416 79.2638 142.623 79.7325C141.83 80.2012 140.882 80.3922 139.76 80.2834C137.778 80.0911 136.402 79.0683 135.903 77.5445L137.87 76.6439C138.117 77.638 138.811 78.1905 139.953 78.3012C141.094 78.4119 141.691 78.0859 141.763 77.345C141.825 76.7043 141.021 76.2423 139.986 75.8791C138.521 75.353 136.557 74.5561 136.801 72.4576C136.89 71.5366 137.302 70.8288 138.058 70.3362C138.813 69.8435 139.721 69.6487 140.762 69.7497C142.424 69.9109 143.69 70.822 144.264 72.1914L142.343 73.0358C142.077 72.2419 141.473 71.7993 140.572 71.7119C139.751 71.6323 139.075 71.9305 139.007 72.6313Z" fill="#17191B"/>
    <g filter="url(#filter3_d_1402_21961)">
      <circle cx="43.7939" cy="33.7354" r="30.4401" transform="rotate(5.54147 43.7939 33.7354)" fill="white"/>
    </g>
    <path d="M48.9923 44.0111L37.0326 42.8507C36.5099 40.461 35.218 38.2231 33.9189 36.0598C33.5959 35.5003 33.2729 34.9408 32.9499 34.3813C31.6653 32.0686 31.0896 29.4474 31.3652 26.607C32.0686 19.3564 38.4719 14.017 45.7972 14.7277C53.0477 15.4311 58.3799 21.9091 57.6692 29.2344C57.4009 32.0001 56.2574 34.4545 54.5521 36.4772C54.1276 36.9641 53.7031 37.4511 53.2786 37.9381C51.5878 39.8113 49.8898 41.7592 48.9923 44.0111ZM42.0842 52.9987C38.7205 52.6723 36.3581 49.8023 36.6845 46.4387L36.8005 45.2427L48.7602 46.403L48.6442 47.599C48.3178 50.9626 45.3731 53.3177 42.0842 52.9987ZM38.541 27.3032C38.8601 24.0143 41.7373 21.5772 45.101 21.9035C45.699 21.9615 46.3477 21.4963 46.413 20.8236C46.471 20.2256 45.9311 19.5696 45.3331 19.5116C40.6987 19.0619 36.5914 22.5115 36.1491 27.0711C36.0838 27.7438 36.5563 28.3178 37.229 28.3831C37.827 28.4411 38.4757 27.9759 38.541 27.3032Z" fill="#FFCA41"/>
    <defs>
      <filter
        id="filter0_d_1402_21961"
        x="38.9474"
        y="32.7126"
        width="271.301"
        height="190.099"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4.75935"/>
        <feGaussianBlur stdDeviation="11.8984"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1402_21961"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1402_21961" result="shape"/>
      </filter>
      <filter
        id="filter1_d_1402_21961"
        x="18.9474"
        y="17.7126"
        width="271.301"
        height="190.099"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4.75935"/>
        <feGaussianBlur stdDeviation="11.8984"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1402_21961"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1402_21961" result="shape"/>
      </filter>
      <filter
        id="filter2_d_1402_21961"
        x="7.94739"
        y="4.7126"
        width="271.301"
        height="190.099"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4.75935"/>
        <feGaussianBlur stdDeviation="11.8984"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1402_21961"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1402_21961" result="shape"/>
      </filter>
      <filter
        id="filter3_d_1402_21961"
        x="13.3516"
        y="3.29297"
        width="90.0991"
        height="90.0991"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="16.142" dy="16.142"/>
        <feGaussianBlur stdDeviation="6.53616"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1402_21961"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1402_21961" result="shape"/>
      </filter>
    </defs>
  </svg>

</template>
